import React from 'react';
import {
  List,
  Filter,
  Datagrid,
  TextField,
  DateField,
  SearchInput,
  EditButton,
  Pagination,
} from 'react-admin';
import ToggleRowStyle from './Common';

const TicketFilter = (props) => (
  <Filter {...props}>
    <SearchInput
      placeholder="Ticket title"
      source="title"
      resettable
      alwaysOn
    />
  </Filter>
);

const TicketList = (props) => {
  return (
    <List {...props} filters={<TicketFilter />} title="List of tickets">
      <Pagination />
      <Datagrid
        rowClick={(id, basePath, record) => {}}
        rowStyle={ToggleRowStyle}
        bulkActionButtons={false}
      >
        <TextField source="title" />
        <DateField source="created_at" label="Date logged" />
        <DateField source="updated_at" label="Date updated" />
        <DateField source="resolved_at" label="Date resolved" />
        <TextField source="status" />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default TicketList;

